<template>
  <div id="my-transfer">
    <div class="rounded box-shadow bg-white p-3 mb-5">
      <my-send v-model="transfer" v-if="transfer.step === 1"></my-send>
      <my-file-list
        v-model="transfer"
        v-else-if="transfer.step === 2"
      ></my-file-list>
      <my-waiting
        v-model="transfer"
        v-else-if="transfer.step === 3"
      ></my-waiting>
      <my-sending
        v-model="transfer"
        v-else-if="transfer.step === 4"
      ></my-sending>
      <my-receiving
        v-model="transfer"
        v-else-if="transfer.step === 5"
      ></my-receiving>
      <my-completed
        title="Send Completed"
        v-model="transfer"
        v-else-if="transfer.step === 6"
      ></my-completed>
    </div>
    <div
      class="rounded box-shadow bg-white p-3 mb-5"
      v-if="transfer.step === 1"
    >
      <my-receive v-model="transfer"></my-receive>
    </div>
  </div>
</template>

<script>
import MySend from "./sub/My-1-Send";
import MyFileList from "./sub/My-2-FileList";
import MyWaiting from "./sub/My-3-Waiting";
import MySending from "./sub/My-4-Sending";
import MyCompleted from "./sub/My-6-Completed";
import MyReceive from "./sub/My-1-Receive";
import MyReceiving from "./sub/My-5-Receiving";
import request from "../../utils/Request";
export default {
  name: "MyTransfer",
  components: {
    MyReceiving,
    MyReceive,
    MyCompleted,
    MySending,
    MyWaiting,
    MyFileList,
    MySend
  },
  data() {
    return {
      transfer: {
        step: 1,
        transfer_key: "",
        is_lan: 0, // 0广域网，1局域网
        files: [],
        filesInfo: {
          files: []
        },
        status: 0,
        errMsg: "",

        receive_client_name: "",
        upload_client_name: ""
      }
    };
  },
  watch: {
    "$store.state.step"(val) {
      this.transfer.step = val;
    },
    "transfer.step"(val, old) {
      /** 取消时修改传输状态*/
      if (this.transfer.status === 5 && (old === 3 || old === 4)) {
        if (this.transfer.is_lan === 1) {
          request({
            baseURL: this.transfer.host_url,
            url: "update-status",
            method: "get",
            withCredentials: false,
            params: {
              keycode: this.transfer.transfer_key,
              status: 5
            }
          });
        }
        request({
          url: "/v1/transfer/set-status",
          data: {
            transfer_type: 1,
            id: this.transfer.id,
            status: 5
          }
        });
      } else if (this.transfer.status === 8 && old === 5) {
        if (this.transfer.is_lan === 1) {
          request({
            baseURL: this.transfer.host_url,
            url: "update-status",
            method: "get",
            withCredentials: false,
            params: {
              keycode: this.transfer.transfer_key,
              status: 8
            }
          });
        }
        request({
          url: "/v1/transfer/set-status",
          data: {
            transfer_type: 1,
            id: this.transfer.id,
            status: 8
          }
        });
      }

      this.$store.commit("set_step", val);
      if (val === 1) {
        this.transfer = {
          step: 1,
          transfer_key: "",
          is_lan: 0, // 0广域网，1局域网
          files: [],
          filesInfo: {
            files: []
          },
          status: 0,
          errMsg: "",

          receive_client_name: "",
          upload_client_name: ""
        };
      }
    }
  },
  mounted() {
    // $(window).on("beforeunload", function(event) {
    // $(window).on("beforeunload", function(event) {
    //   // 离开页面之前
    //   let e = event || window.event;
    //   if (e) {
    //     e.returnValue = "browserclose.alert";
    //   }
    //   return "browserclose.alert";
    // });
    // $(window).on("unload", function() {
    //   // 离开页面
    // });
  }
};
</script>
